// extracted by mini-css-extract-plugin
export default {"container":"ProductDetail_container__5anOw"};